import { isEmpty } from './assertion.utils';

/**
 * @description
 * extracts named keys from a query string and converts them to a key-value object
 * @param paramNames a string array of target named keys inside the query string
 * @param url the url containing the query string
 * @returns a key-value dictionary object
 *
 * example:
 * qs = "?a=1&b=2&c=3" => queryStringToObject(['a', 'c'], qs) => { a: 1, c: 3 }
 */
export function queryStringToObject(paramNames: string[], url: string): { [key: string]: any } {
  let obj: any = {};

  paramNames.forEach((param: any) => {
    obj[param] = valueFromQueryString(param, url);
  });

  return obj;
}

export function valueFromQueryString(name: string, url: string) {
  name = name.replace(/[[]]/g, '$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2]);
}

export function isValidUrl(value: any) {
// this reg dosent work for this address - 'https://cal.cal-online.co.il/#!/sale/hitechzone/6/7/'

  // const urlPattern =
  //   /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;
  // var urlPattern = new RegExp(
  //   '^(https?:\\/\\/)?' + // validate protocol
  //     '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
  //     '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
  //     '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
  //     '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
  //     '(\\#[-a-z\\d_]*)?$',
  //   'i'
  // ); // validate fragment locator
  // return urlPattern.test(value || '');

  try {
    new URL(value);
    return true;
  }
  catch (e) {
   return false;
  }
}

export function toUrlParams(params: any[], options: { includeNulls: boolean } = { includeNulls: false }): string {
  let query = '';
  const { includeNulls } = options;
  params.forEach((param) => {
    if (param) {
      query += '/' + param;
    } else if (includeNulls) {
      query += '/' + null;
    }
  });
  return query;
}

export function userAgent() {
  return window.navigator.userAgent;
}

export function hasQueryString(url: string): boolean {
  const uri = new URL(url);
  // console.log(uri.search)
  // console.log(uri.searchParams)
  return !isEmpty(uri.search);
}
